"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ruleset = undefined;

var _util = require("../../../../util");

var Util = _interopRequireWildcard(_util);

var _overlord = require("./overlord");

var Parent = _interopRequireWildcard(_overlord);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var UTC = Util.Timestamp.UTC;
var TS = Util.Timestamp.wrap;
var TS0 = TS(0);

var ruleset = exports.ruleset = Parent.ruleset;
exports.default = [{
  name: "prerelease",
  ruleset: ruleset,
  auth: { role: "prereleaseFlags" },
  lifecycle: {
    //visibleAt: UTC(2017, "dec", 14),
    openAt: UTC(2017, "dec", 14),
    //visibleAt: TS(Date.now() + 5 * 1000),
    //openAt: TS(Date.now() + 500000 * 1000),
    visibleAt: TS0
    //openAt: TS0,
    //closedAt: TS0,
  }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L3ByZXJlbGVhc2UuanMiXSwibmFtZXMiOlsiVXRpbCIsIlBhcmVudCIsIlVUQyIsIlRpbWVzdGFtcCIsIlRTIiwid3JhcCIsIlRTMCIsInJ1bGVzZXQiLCJuYW1lIiwiYXV0aCIsInJvbGUiLCJsaWZlY3ljbGUiLCJvcGVuQXQiLCJ2aXNpYmxlQXQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7SUFBWUEsSTs7QUFHWjs7SUFBWUMsTTs7OztBQUNaLElBQU1DLE1BQU1GLEtBQUtHLFNBQUwsQ0FBZUQsR0FBM0I7QUFDQSxJQUFNRSxLQUFLSixLQUFLRyxTQUFMLENBQWVFLElBQTFCO0FBQ0EsSUFBTUMsTUFBTUYsR0FBRyxDQUFILENBQVo7O0FBRU8sSUFBTUcsNEJBQW1CTixPQUFPTSxPQUFoQztrQkFDUyxDQUNkO0FBQ0VDLFFBQU0sWUFEUjtBQUVFRCxrQkFGRjtBQUdFRSxRQUFNLEVBQUNDLE1BQU0saUJBQVAsRUFIUjtBQUlFQyxhQUFXO0FBQ1Q7QUFDQUMsWUFBUVYsSUFBSSxJQUFKLEVBQVUsS0FBVixFQUFpQixFQUFqQixDQUZDO0FBR1Q7QUFDQTtBQUNBVyxlQUFXUDtBQUNYO0FBQ0E7QUFQUztBQUpiLENBRGMsQyIsImZpbGUiOiJwcmVyZWxlYXNlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCAqIGFzIFV0aWwgZnJvbSBcIi4uLy4uLy4uLy4uL3V0aWxcIlxuaW1wb3J0IHR5cGUge1N0YXRlIGFzIExlYWd1ZX0gZnJvbSBcIi4uL3Jhd1wiXG5pbXBvcnQgdHlwZSB7U3RhdGUgYXMgUnVsZXNldH0gZnJvbSBcIi4uL3J1bGVzZXRzXCJcbmltcG9ydCAqIGFzIFBhcmVudCBmcm9tIFwiLi9vdmVybG9yZFwiXG5jb25zdCBVVEMgPSBVdGlsLlRpbWVzdGFtcC5VVENcbmNvbnN0IFRTID0gVXRpbC5UaW1lc3RhbXAud3JhcFxuY29uc3QgVFMwID0gVFMoMClcblxuZXhwb3J0IGNvbnN0IHJ1bGVzZXQ6IFJ1bGVzZXQgPSBQYXJlbnQucnVsZXNldFxuZXhwb3J0IGRlZmF1bHQgKFtcbiAge1xuICAgIG5hbWU6IFwicHJlcmVsZWFzZVwiLFxuICAgIHJ1bGVzZXQsXG4gICAgYXV0aDoge3JvbGU6IFwicHJlcmVsZWFzZUZsYWdzXCJ9LFxuICAgIGxpZmVjeWNsZToge1xuICAgICAgLy92aXNpYmxlQXQ6IFVUQygyMDE3LCBcImRlY1wiLCAxNCksXG4gICAgICBvcGVuQXQ6IFVUQygyMDE3LCBcImRlY1wiLCAxNCksXG4gICAgICAvL3Zpc2libGVBdDogVFMoRGF0ZS5ub3coKSArIDUgKiAxMDAwKSxcbiAgICAgIC8vb3BlbkF0OiBUUyhEYXRlLm5vdygpICsgNTAwMDAwICogMTAwMCksXG4gICAgICB2aXNpYmxlQXQ6IFRTMCxcbiAgICAgIC8vb3BlbkF0OiBUUzAsXG4gICAgICAvL2Nsb3NlZEF0OiBUUzAsXG4gICAgfSxcbiAgfSxcbl06IExlYWd1ZVtdKVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/leagues/list/prerelease.js
// module id = 783
// module chunks = 0